import { gql } from '@apollo/client';

export const LEASING_INTERESTS_LIST_QUERY = gql`
  query leasingInterests($pager: PagerInputNew, $filters: LeasingInterestsFilterInput) {
    leasingInterests(pager: $pager, filters: $filters) {
      total
      values {
        interestTypeId
        interestTypeName
        interestTypeCode
        currencyId
        currencyCode
        periodicity
        isFixed
      }
    }
  }
`;
